<template>
  <div class="app-tool" :class="{on:on}">
    <a href="javascript:;" class="icon icon-more" @click="onSwitch"></a>
    <div class="tool-panel">
      <a href="javascript:;" class="icon icon-home" @click="onHome"></a>
      <a href="javascript:;" class="icon icon-search" @click="onSearch"></a>
      <a href="javascript:;" class="icon icon-share" @click="onShare"></a>
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      on () {
        return this.$service.common.tool
      }
    },
    methods: {
      onSwitch () {
        this.$service.common.tool = !this.$service.common.tool
      },
      onHome () {
        if (this.on) {
          if (this.$route.name !== 'home') {
            this.$router.push({name: 'home'})
          } else {
            this.$service.common.tool = false
          }
        }
      },
      onSearch () {
        if (this.on) {
          this.$router.push({name: 'search'})
        }
      },
      onShare () {
        if (this.on) {
          this.$service.common.tool = false
          this.$service.common.share = true
        }
      }
    }
  }
</script>
<style scoped lang='scss'>
  .app-tool {
    position: fixed;
    right: 32px;
    bottom: 120px;
    transition: all 0.3s;
    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: center;
      color: $color-white;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 50%;
    }
    .tool-panel {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      transition: all 0.3s;
      .icon {
        position: absolute;
      }
      .icon-home {
        left: 65px;
        top: -65px;
      }
      .icon-search {
        left: 80px;
      }
      .icon-share {
        left: 57px;
        top: 57px;
      }
    }
    &.on {
      transform: rotate(-140deg);
      .tool-panel {
        opacity: 1;
        .icon {
          transform: rotate(140deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AppTool.vue?dd4ea420